// Wizard Step Definitions
export type WizardStepKey =
  | 'basic_details'
  | 'background_search'
  | 'document_generation'
  | 'document_package'
  | 'signature_verification'
  | 'payroll_integration'
  | 'i9_completion';

export interface WizardStep {
  key: WizardStepKey;
  title: string;
  description: string;
  order: number;
}

export const WIZARD_STEPS: WizardStep[] = [
  {
    key: 'basic_details',
    title: 'Basic Details',
    description: 'Employee information',
    order: 1,
  },
  {
    key: 'background_search',
    title: 'Background Search',
    description: 'Conduct background verification',
    order: 2,
  },
  {
    key: 'document_generation',
    title: 'Document Generation',
    description: 'Create offer letter & NDA',
    order: 3,
  },
  {
    key: 'document_package',
    title: 'Document Package',
    description: 'Prepare for signature',
    order: 4,
  },
  {
    key: 'signature_verification',
    title: 'Signature Verification',
    description: 'Track signed documents',
    order: 5,
  },
  {
    key: 'payroll_integration',
    title: 'Add to QuickBooks',
    description: 'Add to QuickBooks',
    order: 6,
  },
  {
    key: 'i9_completion',
    title: 'I-9 Completion',
    description: 'Complete I-9 verification',
    order: 7,
  },
];

// Wizard Draft Data
export interface WizardDraftData {
  employeeId?: string; // If employee is already created
  employeeData?: Partial<any>; // Employee form data
  stepData?: Record<WizardStepKey, any>; // Step-specific data
  completedSteps?: WizardStepKey[]; // Steps marked as completed
  currentStep?: WizardStepKey;
  createdAt?: string;
  updatedAt?: string;
}

// Step Completion Status
export interface StepCompletionStatus {
  step: WizardStepKey;
  completed: boolean;
  completedAt?: string;
}
